module.exports = __webpack_public_path__ + "static/img/1.5549ce0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newFive/1.png
// module id = 0Z5X
// module chunks = 0